module.exports = __webpack_public_path__ + "img/philippa-gregory.0746d8d9.png";